export const getUnitNumber = (unitId) => {
  const unitAndLesson = unitId.split("U")[1].split(".");
  if (unitAndLesson[0][0] === "0") {
    return unitAndLesson[0][1];
  }
  return unitAndLesson[0];
};
